// @flow

import React from 'react'
import { connect } from 'react-redux'
import findIndex from 'lodash/findIndex'

import { ModalHeader } from '../Modal'
import { EditSnippetInfo } from './EditSnippetInfo'

import { selectCheckedoutPoll } from '../../stores/pollBuilderCheckedoutPoll'
import { getCurrentIcon } from '../../stores/icons/current'
import { selectSelectedExpertOpinion } from '../../stores/pollBuilderSelectedExpertOpinion'
import {
  insertCheckedoutExpertOpinion,
  updateCheckedoutExpertOpinionWhereIndex,
  deleteCheckedoutExpertOpinionWhereIndex,
} from '../../stores/pollBuilderCheckedoutExpertOpinions'

const SnippetInfo = ({
  previewRadius,
  checkedoutPoll,
  currentIcon,
  selectedExpertOpinion,
  onClose,
  onDelete,
  insertExpertOpinion,
  updateExpertOpinion,
  deleteExpertOpinion,
}) => {
  if (!selectedExpertOpinion || !checkedoutPoll) {
    return null
  }

  const newExpertOpinion = !(
    findIndex(checkedoutPoll.expertOpinions, { id: selectedExpertOpinion.id }) >
    -1
  )
  function onSnippetSave(id) {
    return function({ text, name }) {
      if (!newExpertOpinion) {
        updateExpertOpinion(id, {
          text,
          name,
        })
      } else {
        insertExpertOpinion(
          Object.assign({}, selectedExpertOpinion, { text, name })
        )
      }
      onClose()
    }
  }

  function onSnippetDelete(id) {
    return function() {
      deleteExpertOpinion(id)
      onDelete()
    }
  }

  const { file, crop, blob } = currentIcon

  return (
    <div className="content">
      <ModalHeader title="Edit Information Snippet" close={onClose} />

      <EditSnippetInfo
        selectedIcon={selectedExpertOpinion}
        onSave={onSnippetSave(selectedExpertOpinion.id)}
        onDelete={
          newExpertOpinion
            ? undefined
            : onSnippetDelete(selectedExpertOpinion.id)
        }
        name={selectedExpertOpinion.name}
        text={selectedExpertOpinion.text}
        cancel={onClose}
        width={previewRadius}
        height={previewRadius}
        file={file}
        crop={crop}
        blob={blob}
      />
    </div>
  )
}

const mapStateToProps = state => {
  return {
    checkedoutPoll: selectCheckedoutPoll(state),
    currentIcon: getCurrentIcon(state),
    selectedExpertOpinion: selectSelectedExpertOpinion(state),
  }
}

const mapDispatchToProps = {
  insertExpertOpinion: insertCheckedoutExpertOpinion,
  updateExpertOpinion: updateCheckedoutExpertOpinionWhereIndex,
  deleteExpertOpinion: deleteCheckedoutExpertOpinionWhereIndex,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SnippetInfo)



// WEBPACK FOOTER //
// ./src/components/Snippets/SnippetInfo.js